import { toast } from "react-toastify";
import axiosInstance from "../../Shared/Utils/axiosInstance";
import { getANMDetails } from "../../Services/AnmDetailsPhcHeadService.js";
import { getSubcenterList } from "../../Services/AnmService";
export const SET_ANM_DATA = "SET_ANM_DATA";
export const FETCH_ANM_DETAILS = "FETCH_ANM_DETAILS";
export const FETCH_ANM_DETAILS_FAILURE = "FETCH_ANM_DETAILS_FAILURE";
export const FETCH_ANM_DETAILS_SUCCESS = "FETCH_ANM_DETAILS_SUCCESS";
export const UPDATE_ANM_DETAILS = "UPDATE_ANM_DETAILS";
export const UPDATE_ANM_DETAILS_SUCCESS = "UPDATE_ANM_DETAILS_SUCCESS";
export const UPDATE_ANM_DETAILS_FAILURE = "UPDATE_ANM_DETAILS_FAILURE";
export const REJECT_ANM_DETAILS = "REJECT_ANM_DETAILS";
export const REJECT_ANM_DETAILS_SUCCESS = "REJECT_ANM_DETAILS_SUCCESS";
export const REJECT_ANM_DETAILS_FAILURE = "REJECT_ANM_DETAILS_FAILURE";
export const APPROVE_ANM_DETAILS = "APPROVE_ANM_DETAILS";
export const APPROVE_ANM_DETAILS_SUCCESS = "APPROVE_ANM_DETAILS_SUCCESS";
export const APPROVE_ANM_DETAILS_FAILURE = "APPROVE_ANM_DETAILS_FAILURE";
export const FETCH_SUBCENTER_LIST = "FETCH_SUBCENTER_LIST";
export const FETCH_SUBCENTER_LIST_SUCCESS = "FETCH_SUBCENTER_LIST_SUCCESS";
export const FETCH_SUBCENTER_LIST_FAILURE = "FETCH_SUBCENTER_LIST_FAILURE";

const successToastStyle = {
  width: "30rem",
  background: "#DEF0E7",
  color: "#209860",
  borderColor: "2px solid #209860",
};

const errorToastStyles = {
  width: "30rem",
  background: "#DEF0E7",
  color: "#F85F6A",
  borderColor: "2px solid #209860",
};
const ErrorUp = "Error updating ANM details:";
export const fetchANMDetails = (selectedLanguageId,selectedType) => {
  return async (dispatch) => {
    try {
      const data = await getANMDetails(selectedLanguageId,selectedType);
      dispatch({ type: "FETCH_ANM_DETAILS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "FETCH_ANM_DETAILS_FAILURE", payload: error.message });
    }
  };
};

export const updateSubcentersonAnmDetails = (selectedID, subcenters) => {
  return (dispatch) => {
    const requestBody = {
      subcenterIds: subcenters,
    };
    axiosInstance
      .put(`/api/updateANMDetails/${selectedID}`, requestBody)
      .then((response) => {
        dispatch({ type: UPDATE_ANM_DETAILS_SUCCESS });
        toast.success("ANM Details Update request submitted successfully", {
          style: successToastStyle,
        });
      })
      .catch((error) => {
        console.error(ErrorUp, error);
      });
  };
};

export const approveSubcentersonAnmDetails = (selectedID, subcenters) => {
  return (dispatch) => {
    dispatch({ type: APPROVE_ANM_DETAILS });
    const requestBody = {
      subcenterIds: subcenters,
      valid_invalid: true,
    };

    axiosInstance
      .put(`/api/approveRejectANM/${selectedID}`, requestBody)
      .then((response) => {
        console.log(response.data);
        dispatch({ type: APPROVE_ANM_DETAILS_SUCCESS });
        toast.success("ANM Details Update request submitted successfully", {
          style: successToastStyle,
        });
      })
      .catch((error) => {
        dispatch({ type: APPROVE_ANM_DETAILS_FAILURE, payload: error });
        console.error(ErrorUp, error);
      });
  };
};

export const rejectSubcentersonAnmDetails = (selectedID) => {
  return (dispatch) => {
    console.log(selectedID);
    dispatch({ type: REJECT_ANM_DETAILS });
    const requestBody = {
      valid_invalid: false,
      remarks: "Document Proof is required",
    };
    axiosInstance
      .put(`/api/approveRejectANM/${selectedID}`, requestBody)
      .then((response) => {
        console.log(response.data);
        dispatch({ type: REJECT_ANM_DETAILS_SUCCESS });
        toast.success("ANM Request Rejected successfully", {
          style: successToastStyle,
        });
      })
      .catch((error) => {
        dispatch({ type: REJECT_ANM_DETAILS_FAILURE, payload: error });
        console.error(ErrorUp, error);
        toast.error("Failed to Reject ANM Request", {
          style: errorToastStyles,
        });
      });
  };
};
export const fetchSubcenterList = (selectedLanguageId, anmId) => {
  return async (dispatch) => {
    try {
      const data = await getSubcenterList(selectedLanguageId, anmId);
      dispatch({ type: FETCH_SUBCENTER_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: FETCH_SUBCENTER_LIST_FAILURE, payload: error.message });
    }
  };
};
